"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationRail = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = _interopRequireDefault(require("./styles"));

var _Button = _interopRequireDefault(require("../Button"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Drawer = _interopRequireDefault(require("../Drawer"));

var NavigationRail = function NavigationRail(_ref) {
  var className = _ref.className,
      id = _ref.id,
      buttons = _ref.buttons,
      active = _ref.active,
      onChange = _ref.onChange,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["className", "id", "buttons", "active", "onChange"]);
  var classes = (0, _styles.default)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("nav", {
    id: id,
    className: (0, _classnames.default)("prmbl-NavigationRail", classes.root, className),
    "aria-label": otherProps["aria-label"]
  }, buttons.map(function (buttonAttributes, i) {
    var _buttonAttributes$dra;

    var isSelected = i === active;

    var onClick = function onClick() {
      if (onChange) onChange(isSelected ? undefined : i);
    };

    return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
      key: "button-".concat(i),
      type: "icon",
      className: classes.button,
      color: isSelected ? "primary" : undefined,
      onClick: onClick,
      "aria-expanded": buttonAttributes.drawer ? isSelected : undefined,
      "aria-controls": buttonAttributes.drawer ? (_buttonAttributes$dra = buttonAttributes.drawer.props.id) !== null && _buttonAttributes$dra !== void 0 ? _buttonAttributes$dra : "drawer-".concat(i) : undefined,
      "aria-haspopup": buttonAttributes.drawer ? true : false,
      href: buttonAttributes.href // When a drawer is open, allow only its button to be tabbed to
      ,
      tabIndex: active === undefined || isSelected ? undefined : -1
    }, buttonAttributes.buttonProps), buttonAttributes.icon, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: classes.label,
      variant: "caption",
      color: "inherit"
    }, buttonAttributes.label));
  })), buttons.map(function (buttonAttributes, i) {
    var isSelected = i === active;
    var renderedDrawer;

    if (buttonAttributes.drawer) {
      if (buttonAttributes.drawer.type === _Drawer.default) {
        var _buttonAttributes$dra2, _buttonAttributes$dra3;

        renderedDrawer = /*#__PURE__*/_react.default.cloneElement(buttonAttributes.drawer, {
          key: (_buttonAttributes$dra2 = buttonAttributes.drawer.props.id) !== null && _buttonAttributes$dra2 !== void 0 ? _buttonAttributes$dra2 : "drawer-".concat(i),
          id: (_buttonAttributes$dra3 = buttonAttributes.drawer.props.id) !== null && _buttonAttributes$dra3 !== void 0 ? _buttonAttributes$dra3 : "drawer-".concat(i),
          open: isSelected,
          variant: "persistent",
          anchor: "left",
          PaperProps: {
            classes: {
              root: (0, _classnames.default)(classes.drawerRoot, classes.hidden)
            }
          },
          SlideProps: {
            // We need these to be hidden for accessibility reasons when they are not open
            onExited: function onExited(node) {
              node.className += " ".concat(classes.hidden);
            },
            onEnter: function onEnter(node) {
              node.className = node.className.replace(" ".concat(classes.hidden), "");
            },
            appear: true
          }
        });
      } else {
        // Warn when not a drawer, and don't render
        // eslint-disable-next-line no-console
        console.error("The \"drawer\" key on the ".concat(buttonAttributes.label, "\" button is not a Preamble Drawer component. Check the props passed to NavigationRail."));
      }
    }

    return renderedDrawer;
  }));
};

exports.NavigationRail = NavigationRail;
NavigationRail.defaultProps = {
  buttons: []
};
var _default = NavigationRail;
exports.default = _default;